export const collectionName = {
  jinrogames: "jinrogames",
  jinrorooms: "jinrorooms",
  jinroplayinfo: "jinroplayinfo",
  nextplayqueues: "nextplayqueues",
  jinroplayers: "jinroplayers",
  gmjinrogames: "gmjinrogames",
  jinrosecrets: "jinrosecrets",
  survivormessages: "survivormessages",
  jinromessages: "jinromessages",
  killedplayermessages: "killedplayermessages",
  roommessages: "messages",
  jinrogamehistoryqueues: "jinrogamehistoryqueues",
  jinroplayergamehistories: "jinroplayergamehistories",
  jinrogamehistories: "jinrogamehistories",
  users: "users",
  userjinroinfo: "userjinroinfo",
  userstatus: "userstatus",
  slack: "slack",
  guestplayerurlsendingqueue: "guestplayerurlsendingqueue",
  mail: "mail",
  adminReports: "adminreports",
} as const;
